module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-6.a3ecdda1.mp3";